import React, { useState, useEffect } from "react";
import { GridItem, GridContainer } from "./AcquirerForm.styles";
import TextField from "../../textField/TextField";

const AcquirerCommissions = ({
  formValues,
  handleChange,
  handleBlur,
  errors,
  touched,
}) => {
  const {
    blokko: { amountTxProcessing, percentTxProcessing },
  } = formValues;

  // Estados para mantener el formato de visualización
  const [displayAmount, setDisplayAmount] = useState("");
  const [displayPercent, setDisplayPercent] = useState("");

  // Actualizar los valores de visualización cuando cambian los valores del formulario
  useEffect(() => {
    if (amountTxProcessing !== undefined && amountTxProcessing !== null) {
      setDisplayAmount(amountTxProcessing.toString());
    }
  }, [amountTxProcessing]);

  useEffect(() => {
    if (percentTxProcessing !== undefined && percentTxProcessing !== null) {
      setDisplayPercent(percentTxProcessing.toString());
    }
  }, [percentTxProcessing]);

  const handleAmountChange = (event) => {
    const value = event.target.value;
    // Actualizar el estado de visualización
    setDisplayAmount(value);
    // Permitir edición libre sin convertir a número durante la edición
    handleChange({
      target: {
        name: "blokko.amountTxProcessing",
        value: value,
      },
    });
  };

  const handlePercentChange = (event) => {
    const value = event.target.value;
    // Actualizar el estado de visualización
    setDisplayPercent(value);
    // Permitir edición libre sin convertir a número durante la edición
    handleChange({
      target: {
        name: "blokko.percentTxProcessing",
        value: value,
      },
    });
  };

  const handleAmountBlur = (event) => {
    const value = event.target.value;
    // Mantener el formato original como string para preservar ceros finales
    if (value !== "" && !isNaN(parseFloat(value))) {
      // Mantener el formato original en el estado de visualización
      setDisplayAmount(value);
      handleChange({
        target: {
          name: "blokko.amountTxProcessing",
          value: value, // Mantener como string para preservar formato
        },
      });
    }
    handleBlur(event);
  };

  const handlePercentBlur = (event) => {
    const value = event.target.value;
    // Mantener el formato original como string para preservar ceros finales
    if (value !== "" && !isNaN(parseFloat(value))) {
      // Mantener el formato original en el estado de visualización
      setDisplayPercent(value);
      handleChange({
        target: {
          name: "blokko.percentTxProcessing",
          value: value, // Mantener como string para preservar formato
        },
      });
    }
    handleBlur(event);
  };

  return (
    <GridContainer>
      <GridItem xs={12} md={6} padding="15px 15px 15px 0">
        <TextField
          id="blokko.amountTxProcessing"
          name="blokko.amountTxProcessing"
          placeholder="0.00"
          fullWidth
          label="Processing Transaction Fee"
          value={displayAmount}
          onChange={handleAmountChange}
          onBlur={handleAmountBlur}
          required
          error={errors.blokko?.amountTxProcessing}
          touched={touched.blokko?.amountTxProcessing}
        />
      </GridItem>
      <GridItem xs={12} md={6} padding="15px 15px 15px 0">
        <TextField
          id="blokko.percentTxProcessing"
          name="blokko.percentTxProcessing"
          placeholder="0.0000"
          fullWidth
          label="MDR percentage Fee"
          value={displayPercent}
          onChange={handlePercentChange}
          onBlur={handlePercentBlur}
          required
          error={errors.blokko?.percentTxProcessing}
          touched={touched.blokko?.percentTxProcessing}
        />
      </GridItem>
    </GridContainer>
  );
};

export default AcquirerCommissions;
